import Typography from '@mui/material/Typography';
import React from 'react';

import { EmphasisColorMap } from './typography.const';
import { TypographyProps } from './typography.types';

export const Caption: React.FC<TypographyProps> = ({ className, emphasis = 'high', ...props }) => {
  return (
    <Typography
      variant="caption"
      className={className}
      color={EmphasisColorMap[emphasis]}
      {...props}
    />
  );
};
